<div class="container-fluid">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="'/faqs'"
    [currentPageValue]="editMode ? 'Edit FAQ' : 'Add FAQ'"
  ></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="card-body">
      <div class="row">
        <!-- English Question -->
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="englishQ">
              FAQ English Question
            </label>

            <input
              class="form-control"
              id="englishQ"
              [(ngModel)]="faq && faq.englishQuestion"
              placeholder="FAQ English Question"
              type="text"
              required
              pattern="[A-Za-z0-9\s,.'\-!?\@]*"
              #englishQ="ngModel"
            />
            <div *ngIf="englishQ.invalid && englishQ.touched" class="text-danger">
              English Question is required and must only contain English letters and numbers.
            </div>
          </div>
        </div>

        <!-- English Answer -->
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="englishAns">
              FAQ English Answer
            </label>

            <input
              class="form-control"
              id="englishAns"
              [(ngModel)]="faq && faq.englishAnswer"
              placeholder="FAQ English Answer"
              type="text"
              required
              pattern="[A-Za-z0-9\s,.'\-!\@]*"
              #englishAns="ngModel"
            />
            <div *ngIf="englishAns.invalid && englishAns.touched" class="text-danger">
              English Answer is required and must only contain English letters and numbers.
            </div>
          </div>
        </div>

        <!-- Arabic Question -->
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="arabicQ">
              FAQ Arabic Question
            </label>

            <input
              class="form-control"
              id="arabicQ"
              [(ngModel)]="faq && faq.question"
              placeholder="FAQ Arabic Question"
              type="text"
              required
              pattern="[\u0600-\u06FF\s,.'\-!?\@]*"
              #arabicQ="ngModel"
            />
            <div *ngIf="arabicQ.invalid && arabicQ.touched" class="text-danger">
              Arabic Question is required and must only contain Arabic characters.
            </div>
          </div>
        </div>

        <!-- Arabic Answer -->
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="arabicAns">
              FAQ Arabic Answer
            </label>

            <input
              class="form-control"
              id="arabicAns"
              [(ngModel)]="faq && faq.answer"
              placeholder="FAQ Arabic Answer"
              type="text"
              required
              pattern="[\u0600-\u06FF\s,.'\-!\@]*"
              #arabicAns="ngModel"
            />
            <div *ngIf="arabicAns.invalid && arabicAns.touched" class="text-danger">
              Arabic Answer is required and must only contain Arabic characters.
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="type"> Type </label>

            <input
              class="form-control"
              id="type"
              [(ngModel)]="faq && faq.type"
              placeholder="Type"
              type="text"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="rankFormControl">
              Rank
            </label>

            <select
              [(ngModel)]="faq && faq.rank"
              class="form-control"
              id="rankFormControl"
            >
              <option *ngFor="let item of ranks; let i = index" [value]="i + 1">
                {{ i + 1 }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col btns-block">
          <button class="btn btn-primary" type="button" (click)="onAddFAQ()" [disabled]="!englishQ.valid || !englishAns.valid || !arabicQ.valid || !arabicAns.valid">
            {{ editMode ? "Edit" : "Save" }}
          </button>
          <button
            class="btn btn-outline-danger"
            type="button"
            [routerLink]="'/faqs'"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
